import { i18n } from 'platform-lib-app';
export default [
  {
    path: '/home',
    name: 'Home',
    component: () => import('./index.vue'),
    meta: {
      name: i18n.t('common_web_329'),
      keepAlive: true,
    }
  },
];
